import React, { useState,  useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Form, { GroupItem, SimpleItem, Label, RequiredRule } from 'devextreme-react/form';
import { useScreenSize } from '../../../utils/media-query';
import { useAuth } from '../../../contexts/auth';
import LoaderPage from '../../../layouts/loader-page/loader-page';
import BaseFormWithBreadCrumbs from '../../../components/base-form/base-form';
import { useDataSource } from '../../../contexts/dataSource';
import { getSelectBoxPropertiesIdText, getSelectBoxPropertiesIdName } from "../../../utils/default-props.js";
import { passportStatusTypes, travelInsturanceStatusTypes, vaccinationStatusTypes } from "../../../utils/lookup-groups.ts";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Paging,
    Lookup
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';
import { v4 as uuidv4 } from 'uuid';


const dateEditorOptions = { displayFormat: 'dd.MM.yyyy', type: 'date' };
const timeEditorOptions = { displayFormat: 'HH:mm', type: 'time' };

function TravelCard() {
    const params = useParams();
    const { user } = useAuth();
    const screenSize = useScreenSize();
    const formRef = useRef();
    const id = params.id;
    const [dirty, setDirty] = useState(false)
    const { dataSourceHR } = useDataSource()
    const [loading, setLoading] = useState(false);


    const [formData, setFormData] = useState({
        employeeTravelPurposeId: "",
        description: "",
        employeeTravelPlans: [

        ]
    });


    const dbVaccinationStatusDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + vaccinationStatusTypes.id,
        loadMode: "raw"
    }), [user])

    const dbTravelInsuranceStatusDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + travelInsturanceStatusTypes.id,
        loadMode: "raw"
    }), [user])

    const dbTravelPassportStatusTypes = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + passportStatusTypes.id,
        loadMode: "raw"
    }), [user])

    const employeeDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw"
    }), [user])

    const dbEmployeeTravelPurpose = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelPurpose`,
        loadMode: "raw"
    }), [user])

    const dbEmployeeTravelTransport = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelTransport`,
        loadMode: "raw"
    }), [user])

    const dbEmployeeTravelAccommodation = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelAccommodation`,
        loadMode: "raw"
    }), [user])

    const employeeTravelTransportEditorOptions = {
        dataSource: dbEmployeeTravelTransport,
        ...getSelectBoxPropertiesIdName,
    }

    const employeeTravelPurposeEditorOptions = {
        dataSource: dbEmployeeTravelPurpose,
        ...getSelectBoxPropertiesIdName,
    }

    const employeeTravelAccommodationEditorOptions = {
        dataSource: dbEmployeeTravelAccommodation,
        ...getSelectBoxPropertiesIdName,
    }

    const travelInsuranceStatusEditorOptions = {
        dataSource: dbTravelInsuranceStatusDataSource,
        ...getSelectBoxPropertiesIdName,
    }

    const passportStatusEditorOptions = {
        dataSource: dbTravelPassportStatusTypes,
        ...getSelectBoxPropertiesIdName,
    }

    const vaccinationStatusEditorOptions = {
        dataSource: dbVaccinationStatusDataSource,
        ...getSelectBoxPropertiesIdName,
    }


    const handleChange = (e) => {
        setDirty(true);

        if (e.dataField === "employeeName") {
            setFormData(prev => ({
                ...prev,
                employeeId: e.value
            }));
        }
    };

    const employeEditorOptions = {
        dataSource: employeeDataSource,
        ...getSelectBoxPropertiesIdText
    }

    const dbVaccinationStatus = useMemo(() =>
        dataSourceHR({
            loadUrl: `/api/LookupData/LookupGroup/${vaccinationStatusTypes.id}`,
            loadMode: "raw"
        }), [user]);

    const dbPassportStatus = useMemo(() =>
        dataSourceHR({
            loadUrl: `/api/LookupData/LookupGroup/${passportStatusTypes.id}`,
            loadMode: "raw"
        }), [user]);

    const dbTravelInsuranceStatus = useMemo(() =>
        dataSourceHR({
            loadUrl: `/api/LookupData/LookupGroup/${travelInsturanceStatusTypes.id}`,
            loadMode: "raw"
        }), [user]);


    return (
        <LoaderPage loading={loading}>
            <div className="content-block">
                <div className="dx-card responsive-paddings">
                    <BaseFormWithBreadCrumbs
                        formData={formData}
                        setFormData={setFormData}
                        formRef={formRef}
                        loadId={id}
                        loadUrl="api/EmployeeTravel"
                        updateUrl="api/EmployeeTravel/FormData"
                        dataLoading={loading}
                        setDataLoading={setLoading}
                        dirty={dirty}
                    >
                        <Form
                            formData={formData}
                            labelLocation={screenSize.isXSmall ? "top" : "left"}
                            ref={formRef}
                            width={650}
                            onFieldDataChanged={(e) => handleChange(e)}

                        >
                            <GroupItem caption="Seyahat Talebi Oluşturma" >

                                <SimpleItem
                                    dataField="description"
                                    editorType="dxTextBox"
                                >
                                    <Label text="Açıklama" />
                                    <RequiredRule />
                                </SimpleItem>

                                <SimpleItem
                                    dataField="employeeTravelPurposeId"
                                    editorType="dxSelectBox"
                                    editorOptions={employeeTravelPurposeEditorOptions}>
                                    <Label text="Seyahat Amacı" />
                                    <RequiredRule />
                                </SimpleItem>


                            </GroupItem>
                        </Form>
                        <DataGrid
                            dataSource={formData.employeeTravelPlans}
                            keyExpr="id"
                            showBorders={true}
                            columnAutoWidth={true}
                            repaintChangesOnly={true}

                            onRowInserting={(e) => {
                                e.data.id = uuidv4(); 
                            }}

                            onRowInserted={(e) => {
                                console.log("Yeni satır eklendi:", e.data);
                            }}


                            onRowUpdated={(e) => {
                                const updated = formData.employeeTravelPlans.map(item =>
                                    item.id === e.key ? { ...item, ...e.data } : item
                                );
                                setFormData({ ...formData, employeeTravelPlans: updated });
                            }}

                            onRowRemoved={(e) => {
                                const updated = formData.employeeTravelPlans.filter(item => item.id !== e.key);
                                setFormData({ ...formData, employeeTravelPlans: updated });
                            }}
                        >

                            <Editing
                                mode="form"
                                allowUpdating={true}
                                allowAdding={true}
                                allowDeleting={true}
                                useIcons={true}
                            />

                            <Column
                                dataField="employeeId"
                                caption="Personel"
                                editorType="dxSelectBox"
                                editorOptions={employeEditorOptions}
                            >
                                <Lookup dataSource={employeeDataSource} valueExpr="id" displayExpr="text" />
                            </Column>

                            <Column
                                dataField="employeeTravelTransportId"
                                caption="Ulaşım Türü"
                                editorType="dxSelectBox"
                                editorOptions={employeeTravelTransportEditorOptions}
                            >
                                <Lookup
                                    dataSource={dbEmployeeTravelTransport}
                                    valueExpr="id"
                                    displayExpr="name"  
                                />
                            </Column>


                            <Column
                                dataField="employeeTravelAccommodationId"
                                caption="Konaklama"
                                editorType="dxSelectBox"
                                editorOptions={employeeTravelAccommodationEditorOptions}
                            >
                                <Lookup
                                    dataSource={dbEmployeeTravelAccommodation}
                                    valueExpr="id"
                                    displayExpr="name"  
                                />
                            </Column>


                            <Column
                                dataField="passportStatusTypeId"
                                caption="Pasaport"
                                editorType="dxSelectBox"
                                editorOptions={passportStatusEditorOptions}
                            >
                                <Lookup
                                    dataSource={dbPassportStatus}
                                    valueExpr="id"
                                    displayExpr="text"
                                />
                            </Column>

                            <Column
                                dataField="travelInsuranceStatusTypeId"
                                caption="Sigorta"
                                editorType="dxSelectBox"
                                editorOptions={travelInsuranceStatusEditorOptions}
                            >
                                <Lookup
                                    dataSource={dbTravelInsuranceStatus}
                                    valueExpr="id"
                                    displayExpr="text"
                                />
                            </Column>

                            <Column
                                dataField="vaccinationStatusTypeId"
                                caption="Aşı"
                                editorType="dxSelectBox"
                                editorOptions={vaccinationStatusEditorOptions}
                            >
                                <Lookup
                                    dataSource={dbVaccinationStatusDataSource}
                                    valueExpr="id"
                                    displayExpr="text"
                                />
                            </Column>

                          

                            <Column
                                dataField="businessAdvance"
                                caption="İş Avansı"
                                dataType="number"
                            />
                            <Column
                                dataField="startDate"
                                caption="Başlama Tarihi"
                                dataType="date"
                                editorOptions={dateEditorOptions}
                            />


                            

                            <Column
                                dataField="endDate"
                                caption="Bitiş Tarihi"
                                dataType="date"
                                editorOptions={dateEditorOptions}
                            />

                            <Column
                                dataField="fromWhere"
                                caption="Nereden"
                                dataType="string"
                            />

                            <Column
                                dataField="toWhere"
                                caption="Nereye"
                                dataType="string"
                            />

                              <Column
                                dataField="approvalDate"
                                caption="Onay Tarihi"
                                dataType="date"
                                editorOptions={dateEditorOptions}


                            />

                            <Column
                                dataField="approvalStatus"
                                caption="Onay Durumu"
                                dataType="boolean"
                            />
                        </DataGrid>

                    </BaseFormWithBreadCrumbs>
                </div>
            </div>

           
        </LoaderPage>
    )
}

export default TravelCard